const REPORT_INTERVAL = 600000; // 1000 * 60 * 60 * 24 // 24 hours

let timer: any;

export default (func?: () => any): NodeJS.Timeout => {
	if (!timer && func) {
		timer = setInterval(func, REPORT_INTERVAL);
	}

	return timer;
};
